import { ConfirmActionDialogRef, ConfirmActionDialog } from "@/components/ConfirmActionDialog";
import { LoadingSmall } from "@/components/LoadingSmall";
import { Button } from "@/components/ui/button";
import { showApiError, showSuccess } from "@/lib/toast";
import { requestNewLicence } from "@/sideEffects/api";
import { selectActiveFirm } from "@/store/appSelectors";
import { useMutation } from "@tanstack/react-query";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export const RequestNewLicenceButton = () => {
  const dialogRef = useRef<ConfirmActionDialogRef>(null);
  const activeFirm = useSelector(selectActiveFirm);
  const { t } = useTranslation();

  const requestMutation = useMutation({
    mutationFn: () => requestNewLicence(String(activeFirm?.firmGuid)),
    onError: showApiError,
    onSuccess: () => {
      showSuccess(t("common.requestedSuccess"));
      dialogRef?.current?.close();
    },
  });

  return (
    <ConfirmActionDialog
      ref={dialogRef}
      title={t("dashboard.requestNewLicenceConfirmTitle")}
      description={t("dashboard.requestNewLicenceConfirmDesc")}
      confirmButtonText={t("dashboard.requestNewLicence")}
      trigger={
        <Button size="sm" variant="outline">
          {t("dashboard.requestNewLicence")}
          {requestMutation.isPending && <LoadingSmall />}
        </Button>
      }
      onConfirm={() => requestMutation.mutate()}
      isLoading={requestMutation.isPending}
    />
  );
};
